export default {
  "profile": {
    "personalDetailsSections": "Secciones de datos personales",
    "middleNameS": "Segundo nombre",
    "preferredDisplayName": "Nombre preferido o visible",
    "leaveBlankIfNotApplicable": "Déjalo en blanco si no corresponde.",
    "mobileNumber": "Número de móvil",
    "allergyDetails": "Detalles de alergias",
    "dietaryLifestyleNotes": "Notas de alimentación y estilo de vida",
    "searchActiveClubMembers": "Buscar socios activos del club",
    "nameOrMembershipNumber": "Nombre o número de socio",
    "selectedMemberIsMy": "El socio seleccionado es mi",
    "membershipStatus": "Estado de la membresía",
    "currentAvatar": "Foto actual",
    "mr": "Sr.",
    "mrs": "Sra.",
    "miss": "Srta.",
    "ms": "Sra.",
    "dr": "Dr./Dra.",
    "prof": "Prof.",
    "sir": "Sir",
    "dame": "Dame",
    "lord": "Lord",
    "lady": "Lady",
    "rev": "Rvdo./Rvda.",
    "work": "Trabajo",
    "holidayHome": "Casa de vacaciones",
    "postal": "Postal",
    "car": "Coche",
    "motorcycle": "Motocicleta",
    "van": "Furgoneta",
    "golfBuggy": "Carrito de golf",
    "grandparent": "Abuelo/a",
    "grandchild": "Nieto/a",
    "dependant": "Persona dependiente",
    "label": "Etiqueta",
    "addressType": "Tipo de dirección",
    "addressLine1": "Dirección, línea 1",
    "addressLine2": "Dirección, línea 2",
    "townOrCity": "Localidad o ciudad",
    "countyStateOrRegion": "Provincia, estado o región",
    "postcodeOrZIPCode": "Código postal",
    "country": "País",
    "registrationLicencePlate": "Matrícula",
    "make": "Marca",
    "model": "Modelo",
    "colour": "Color",
    "vehicleType": "Tipo de vehículo",
    "fullName": "Nombre completo",
    "relationship": "Parentesco",
    "alternativeTelephone": "Teléfono alternativo",
    "emailAddress": "Correo electrónico",
    "otherDietaryRequirement": "Otra necesidad alimentaria",
    "recreational": "Recreativo",
    "social": "Social",
    "club": "Club",
    "competitive": "Competitivo",
    "elite": "Élite",
    "discardChanges": "¿Descartar los cambios?",
    "youHaveUnsavedChanges": "Tienes cambios sin guardar.",
    "ifYouContinueYourChangesWillBeLost": "Si continúas, perderás los cambios.",
    "discard": "Descartar",
    "removeFamilyRelationship": "¿Eliminar el vínculo familiar?",
    "thisWillRemoveTheFamilyRelationshipForBothMembers": "Se eliminará el vínculo familiar para ambos socios.",
    "thisActionCannotBeUndoneAutomatically": "Esta acción no se puede deshacer automáticamente.",
    "keepRelationship": "Mantener vínculo",
    "removeVehicle": "¿Eliminar el vehículo?",
    "removeAddress": "¿Eliminar la dirección?",
    "thisVehicleWillBeRemovedFromYourProfile": "Este vehículo se eliminará de tu perfil.",
    "thisAddressWillBeRemovedFromYourProfile": "Esta dirección se eliminará de tu perfil.",
    "saveChanges": "Guardar cambios",
    "sending": "Enviando…",
    "sendRequest": "Enviar solicitud",
    "removing": "Eliminando…",
    "confirming": "Confirmando…",
    "accepting": "Aceptando…",
    "confirmRemoval": "Confirmar eliminación",
    "acceptRelationship": "Aceptar vínculo",
    "keeping": "Manteniendo…",
    "rejecting": "Rechazando…",
    "reject": "Rechazar",
    "removalRequest": "Solicitud de eliminación",
    "cancelling": "Cancelando…",
    "cancelRequest": "Cancelar solicitud",
    "addVehicle": "Añadir vehículo",
    "addAddress": "Añadir dirección",
    "mainPostalAddress": "Dirección postal principal",
    "saveVehicle": "Guardar vehículo",
    "saveAddress": "Guardar dirección",
    "primary": "Principal",
    "uploading": "Subiendo…",
    "uploadNewPhoto": "Subir una foto nueva",
    "updated": "Actualizado.",
    "memberNumberUnavailable": "Número de socio no disponible",
    "enterAtLeastTwoCharactersToFindAnActive": "Introduce al menos dos caracteres para buscar un socio activo del club.",
    "keepTypingToSearchActiveClubMembers": "Sigue escribiendo para buscar socios activos del club.",
    "noMatchingMembersFound": "No se han encontrado socios.",
    "hasRequestedToRemoveYourFamilyRelationship": "Ha solicitado eliminar vuestro vínculo familiar.",
    "hasRequestedToAddYouAsTheirRelation": "Ha solicitado añadirte con el parentesco: {relation}.",
    "relationRelationshipRequest": "Solicitud de parentesco: {relation}",
    "unableToRemoveVehicle": "No se ha podido eliminar el vehículo.",
    "unableToRemoveAddress": "No se ha podido eliminar la dirección.",
    "weCouldNotSaveYourChangesYourEditsAre": "No se han podido guardar los cambios. Tus cambios siguen aquí. Inténtalo de nuevo.",
    "weCouldNotLoadYourDetailsPleaseTryAgain": "No se han podido cargar tus datos. Inténtalo de nuevo.",
    "yourSessionOrAccessCouldNotBeVerifiedPlease": "No se ha podido verificar tu sesión o acceso. Inicia sesión de nuevo o contacta con el club.",
    "thisServiceIsUnavailablePleaseReopenTheAppOr": "Este servicio no está disponible. Abre la aplicación de nuevo o contacta con el club.",
    "pleaseCheckTheHighlightedFieldsAndTryAgain": "Revisa los campos indicados e inténtalo de nuevo.",
    "saved": "Guardado.",
    "yourChangesWereSavedButTheProfileSummaryCould": "Los cambios se han guardado, pero no se ha podido actualizar el resumen del perfil.",
    "refreshSummary": "Actualizar resumen",
    "enterAValidEmailAddress": "Introduce una dirección de correo válida.",
    "enterAValidTelephoneNumber": "Introduce un número de teléfono válido.",
    "invalidDate": "Introduce una fecha válida.",
    "dateCannotBeInTheFuture": "La fecha no puede ser futura.",
    "enterAMoreRecentDate": "Introduce una fecha más reciente.",
    "addressLine1TownCityAndCountryAreRequired": "La dirección, la ciudad y el país son obligatorios.",
    "registrationIsRequired": "La matrícula es obligatoria.",
    "htmlIsNotAllowed": "No se permite HTML.",
    "maximumCountCharacters": "Máximo {count} caracteres.",
    "pleaseSelectAnImageFile": "Selecciona un archivo de imagen",
    "pleaseChooseAnImageUnder8MB": "Elige una imagen de menos de 8 MB",
    "unableToRemovePhoto": "No se ha podido eliminar la foto",
    "unableToSavePortraitPreferenceRightNow": "No se ha podido guardar la preferencia del retrato. Inténtalo de nuevo.",
    "enter00360OrUseForA": "Introduce 0.0–36.0, o usa + para un hándicap positivo de hasta +5.0.",
    "profilePhotoUpdated": "Foto de perfil actualizada.",
    "ready": "Listo",
    "yourPortraitIsNowLive": "Tu retrato animado está listo.",
    "weArePreparingYourPortrait": "Estamos preparando tu retrato.",
    "profilePhotoRemoved": "Foto de perfil eliminada.",
    "notSet": "Sin establecer",
    "addYourLevelForBetterMatchesAndRecommendations": "Añade tu nivel para mejorar las partidas y recomendaciones.",
    "handicap": "Hándicap",
    "levelNumber": "Nivel {number}",
    "notSaved": "Sin guardar",
    "setLevel": "Establecer nivel",
    "currentHandicap": "Hándicap actual",
    "currentTier": "Nivel actual",
    "golfHandicap": "Hándicap de golf",
    "preparing": "Preparando…",
    "bringProfileToLife": "Animar el perfil",
    "switchToPhoto": "Cambiar a foto",
    "switchToLivePortrait": "Cambiar a retrato animado",
    "livePortrait": "Retrato animado",
    "sportPlayingLevel": "Nivel de juego de {sport}",
    "golfHandicapNumber": "Hándicap de golf {number}",
    "sportTierLevelNumber": "{sport}, nivel {tier}, nivel {number}",
    "handicapNumber": "Hándicap {number}",
    "nameLivePortrait": "Retrato animado de {name}",
    "viewPhoto": "Ver foto",
    "viewLivePortrait": "Ver retrato animado",
    "tierLevel": "Nivel {tier}"
  },
  "dining": {
    "somethingWentWrongPleaseTryAgain": "Algo ha fallado. Inténtalo de nuevo.",
    "thatTableTimeWasJustBookedPleaseChooseAnother": "Ese horario acaba de reservarse. Elige otro horario disponible.",
    "chooseAValidDateAndTimeInYourClub": "Elige una fecha y hora válidas en la zona horaria de tu club.",
    "thisReservationIsNowInsideTheClubSCancellation": "Esta reserva ya está dentro del plazo límite de cancelación. Contacta con el club.",
    "yourMemberSessionHasExpiredPleaseSignInAgain": "Tu sesión de socio ha caducado. Inicia sesión de nuevo.",
    "youAppearToBeOfflineCheckYourConnectionAnd": "Parece que no tienes conexión. Compruébala e inténtalo de nuevo.",
    "thisPartySizeIsNotSupportedForOnlineReservations": "Este número de comensales no admite reservas en línea.",
    "thisDiningAreaIsNotTakingReservationsOnThe": "Este espacio de restauración no admite reservas en la fecha seleccionada.",
    "theSelectedDateOrTimeIsInsideTheMinimum": "La fecha u hora seleccionada no cumple la antelación mínima.",
    "onlineReservationsAreNotCurrentlyAvailableForThisDining": "Las reservas en línea no están disponibles actualmente para este espacio de restauración.",
    "weCouldnTCheckTableAvailabilityPleaseTryAgain": "No se ha podido consultar la disponibilidad de mesas. Inténtalo de nuevo.",
    "noTablesAreAvailableForThatDateTryAnother": "No hay mesas disponibles para esa fecha. Prueba con otra fecha u horario.",
    "diningReservationsAreNotCurrentlyAvailable": "Las reservas de restauración no están disponibles actualmente.",
    "someDiningInformationCouldNotBeRefreshed": "No se ha podido actualizar parte de la información de restauración.",
    "weCouldnTReadTheAvailableTimesPleaseTry": "No se han podido leer los horarios disponibles. Inténtalo de nuevo.",
    "yourReservationCouldNotBeCompleted": "No se ha podido completar tu reserva.",
    "theReservationCouldNotBeCancelled": "No se ha podido cancelar la reserva.",
    "confirmed": "Confirmada",
    "seated": "En la mesa",
    "noShow": "No presentado",
    "diningArea": "Espacio de restauración",
    "dismissError": "Cerrar error",
    "loadingDiningAreas": "Cargando espacios de restauración",
    "removeOneGuest": "Quitar un comensal",
    "addOneGuest": "Añadir un comensal",
    "loadingAvailableTimes": "Cargando horarios disponibles",
    "findAvailableTables": "Buscar mesas disponibles",
    "yourSearchWasNotTreatedAsAnEmptyResult": "Tu búsqueda no se ha considerado un resultado sin disponibilidad.",
    "tryNearbyTimesAnotherDateOrAdjustYourParty": "Prueba con horarios próximos, otra fecha o un número distinto de comensales.",
    "changeDate": "Cambiar fecha",
    "allergiesAccessibilityRequirementsBirthdaysOrAnniversaries": "Alergias, necesidades de accesibilidad, cumpleaños o aniversarios…",
    "reservingYourTable": "Reservando tu mesa…",
    "updateReservation": "Actualizar reserva",
    "reserveTable": "Reservar mesa",
    "loadingReservations": "Cargando reservas",
    "noPreviousReservations": "Sin reservas anteriores",
    "closeReservationDetails": "Cerrar detalles de la reserva",
    "diningAreaUnavailable": "Espacio de restauración no disponible",
    "unavailable": "No disponible",
    "onlineCancellationIsAvailable": "La cancelación en línea está disponible.",
    "submitted": "enviada",
    "nameDiningArea": "Espacio de restauración {name}",
    "countGuest": "{count} comensal",
    "countGuests": "{count} comensales",
    "countRecent": "{count} recientes",
    "timeUnavailable": "Hora no disponible",
    "dateUnavailable": "Fecha no disponible",
    "chooseADiningAreaDateAndValidPartySize": "Elige un espacio de restauración, una fecha y un número válido de comensales.",
    "countRecentOne": "{count} reciente"
  },
  "golf": {
    "preparingYourRound": "Preparando tu ronda",
    "gettingCoursesAndPlayersReady": "Preparando los campos y jugadores",
    "loadingScoringTees": "Cargando tees de puntuación",
    "loadingActiveRounds": "Cargando rondas activas",
    "golfCourse": "Campo de golf",
    "startingRound": "Iniciando la ronda…",
    "startRound": "Iniciar ronda",
    "deleteRound": "Eliminar ronda",
    "course": "Campo",
    "golfSetupStep": "Configuración de golf: {step}",
    "strokePlay": "Juego por golpes",
    "countEveryStrokeAcrossTheRound": "Cuenta todos los golpes de la ronda.",
    "stableford": "Stableford",
    "playForPointsOnEveryHole": "Juega por puntos en cada hoyo.",
    "nameTees": " · tees {name}",
    "weCouldnTStartTheRoundNothingHasBeen": "No se ha podido iniciar la ronda. No se ha registrado nada; inténtalo de nuevo.",
    "deleteCourseRound": "Eliminar la ronda de {course}",
    "guestName": "Invitado — {name}",
    "removeName": "Eliminar a {name}",
    "today": "Hoy",
    "yesterday": "Ayer",
    "checkingSportAvailability": "Comprobando los deportes disponibles",
    "loadingClubSports": "Cargando deportes del club",
    "findingWhatSAvailableToday": "Consultando las opciones de hoy",
    "playARound": "Jugar una ronda",
    "takeToTheCourt": "Salir a la pista",
    "loadingLetSPlay": "Cargando Vamos a jugar",
    "weCouldnTLoadThisCompletedActivity": "No se ha podido cargar esta actividad completada.",
    "momentFromName": "Momento de {name}",
    "round": "ronda",
    "activity": "actividad",
    "countHoles": "{count} hoyos · ",
    "countHoles225": " · {count} hoyos",
    "round226": "Ronda",
    "round227": "Ronda",
    "preparingYourActivitySummary": "Preparando el resumen de tu actividad",
    "loadingActivity": "Cargando actividad",
    "roundCOMPLETE": "RONDA COMPLETADA",
    "countBirdie": "{count} birdie",
    "countBirdies": "{count} birdies",
    "countEagle": "{count} eagle",
    "countEagles": "{count} eagles",
    "countAlbatross": "{count} albatros",
    "countAlbatrosses": "{count} albatros",
    "countHoleInOne": "{count} hoyo en uno",
    "countHolesInOne": "{count} hoyos en uno",
    "weCouldnTLoadYourHistory": "No se ha podido cargar tu historial.",
    "countHoles240": " · {count} hoyos",
    "round241": "Ronda",
    "round242": "Ronda",
    "birdie": "BIRDIE",
    "nicelyJudged": "Bien calculado.",
    "cleanWork": "Un golpe impecable.",
    "oneBetter": "Uno bajo par.",
    "thatLlPlay": "Así se juega.",
    "eagle": "EAGLE",
    "thatLlDo": "Así está bien.",
    "twoBetterVeryTidy": "Dos bajo par. Impecable.",
    "nowWeReTalking": "Eso ya es otra cosa.",
    "exceptional": "Excepcional.",
    "albatross": "ALBATROS",
    "wellThatEscalated": "Eso ha sido espectacular.",
    "threeUnderAbsurd": "Tres bajo par. Increíble.",
    "youDonTSeeThatEveryDay": "Eso no se ve todos los días.",
    "ridiculousInTheBestWay": "Una locura. En el mejor sentido.",
    "holeINONE": "HOYO EN UNO",
    "oneSwingThatSAllItTook": "Un golpe. No hizo falta más.",
    "someoneSBuyingTheDrinks": "Alguien invita a las bebidas.",
    "straightInTheHistoryBook": "Directo al libro de los récords.",
    "perfectlyUnnecessarySecondShot": "El segundo golpe sobraba.",
    "titleForName": "{title} para {name}.",
    "preparingYourMoment": "Preparando tu momento…",
    "continueAfterTitleForName": "Continuar tras {title} de {name}",
    "thisRoundWillBeRemovedFromLetSPlay": "Esta ronda se eliminará de Vamos a jugar y no podrás seguir anotando resultados."
  }
}
